import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const signes = [
  "Télécommande qui ne répond plus",
  "Portée de la télécommande fortement réduite",
  "Bouton mural inopérant ou qui ne répond plus",
  "Perte de programmation après une coupure de courant",
];

export default function Signes() {
  return (
    <section className="bg-[#F5F2EB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-5">
              Signes que le remplacement est nécessaire
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Une télécommande ou un point de commande de volet roulant peut tomber en panne pour plusieurs raisons : usure des boutons, décharge des piles, dysfonctionnement du récepteur radio ou perte de programmation. Voici les signes qui indiquent qu&apos;il est temps de faire intervenir un professionnel pour le remplacement.
            </p>
            <ul className="space-y-3 mb-8">
              {signes.map((signe) => (
                <li key={signe} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#E8734A]/10 shrink-0">
                    <i className="ri-check-line text-[#E8734A] text-sm"></i>
                  </span>
                  <span className="text-[#1B2A4A] text-base font-medium">{signe}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-2xl overflow-hidden">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20defective%20white%20roller%20shutter%20remote%20control%20with%20worn%20buttons%20and%20a%20cracked%20casing%20on%20a%20modern%20coffee%20table%20showing%20clear%20signs%20of%20needing%20replacement%20clean%20daylight%20professional%20photography%20warm%20neutral%20tones&width=700&height=520&seq=tele-signes&orientation=landscape" alt="Télécommande de volet roulant défectueuse à remplacer" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}